/**
 * Paginado de los listados. El message log es grande: pagina la API, no la UI.
 */
import type { ReactElement } from 'react';
import { PAGE_SIZE_OPTIONS } from '../lib/filters';

export interface PaginationProps {
  readonly page: number;
  readonly pageSize: number;
  readonly total: number;
  readonly onPageChange: (page: number) => void;
  readonly onPageSizeChange: (pageSize: number) => void;
}

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}: PaginationProps): ReactElement {
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const first = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);

  return (
    <div className="pagination">
      <span className="pagination__summary">
        {total === 0 ? 'Sin resultados' : `${first}–${last} de ${total}`}
      </span>

      <label className="row">
        <span className="muted">Por página</span>
        <select
          className="select select--auto select--sm"
          aria-label="Resultados por página"
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number.parseInt(event.target.value, 10))}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>

      <div className="row pagination__pages">
        <button
          type="button"
          className="button button--sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
        >
          Anterior
        </button>
        <span className="muted">
          Página {page} de {lastPage}
        </span>
        <button
          type="button"
          className="button button--sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= lastPage}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}
